import React from "react";
import Logo from "../../assets/images/Logo/Logo.svg";
import moment from "moment/moment";
import { Col, Row, Space, Button, theme, Dropdown, Tooltip } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import config from "../../config";

import { ChevronDownIcon, PlusCircleIcon, MoonIcon, SunIcon } from "@heroicons/react/24/solid";
import {
  CreditCardOutlined,
  EditOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import Notifications from "./Notifications";
import { clearStorageKeepTheme, useTheme } from "../../components/Shared/ThemeContext";

function ControlHeader(props) {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const pumpCode = localStorage.getItem("pumpCode");
  const PackageName = localStorage.getItem("PackageName");
  const PackageExpiry = localStorage.getItem("PackageExpiry");
  const Full_Name = localStorage.getItem("AdminFull_Name");
  const PumpName = localStorage.getItem("PumpName");
  const EmailAddress = localStorage.getItem("Email_Address");
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Profile, setProfile] = useState({});
  const [Logo_Login, setLogoLogin] = useState("");
  const [Email, setEmail] = useState("");
  const navigate = useNavigate();
  const { isDark, toggleTheme } = useTheme();

  const handleClick = () => {
    const side_bar = document.getElementById("side-bar");
    const menubutton = document.getElementById("menubutton");
    const overlaymenu = document.getElementById("overlaymenu");
    if (menubutton) {
      menubutton.classList.toggle("active");
    }

    if (overlaymenu) {
      overlaymenu.classList.toggle("active");
    }

    if (side_bar) {
      side_bar.classList.toggle("active");
    }
  };

  const handleSignOut = () => {
    clearStorageKeepTheme();
    navigate("/controlbase/login");
  };

  const items = [
    {
      key: "1",
      icon: <LogoutOutlined />,
      label: (
        <a type="button" rel="noopener noreferrer" onClick={handleSignOut}>
          Sign Out
        </a>
      ),
    },
  ];

  return (
    <>
      <header id="dashboard-header">
        <div>
          <div className="header-left">
            <img src={Logo} style={{ width: 100 }} alt="Fuelbook" />
          </div>
        </div>
        <div className="header-right">
          <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
            <Button
              type="text"
              className="theme-toggle-btn"
              shape="circle"
              aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
              onClick={toggleTheme}
              icon={
                isDark ? (
                  <SunIcon style={{ width: 18, height: 18 }} />
                ) : (
                  <MoonIcon style={{ width: 18, height: 18 }} />
                )
              }
            />
          </Tooltip>
          <Dropdown
            trigger={["click"]}
            menu={{
              items,
            }}
          >
            <div className="button-user-in">
              <div className="short-name">{Full_Name}</div>
              <ChevronDownIcon />
            </div>
          </Dropdown>
        </div>
        <svg
          className={`ham hamRotate ham8`}
          id="menubutton"
          onClick={handleClick}
          viewBox="0 0 100 100"
          width="80"
        >
          <path
            className="line top"
            d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"
          />
          <path className="line middle" d="m 30,50 h 40" />
          <path
            className="line bottom"
            d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"
          />
        </svg>
      </header>
    </>
  );
}

export default ControlHeader;
